import {
	NewProductStatisticsData,
	상품매출커스터마이즈종류Type,
} from '@kinderlabs-pos/feature/pos/statistics';
import { useSimpleReactTable } from '@kinderlabs-pos/frameworks/table';
import {
	DayCalendarFilterOptionType,
	SalesDeviceInfoType,
	getSalesDeviceInfoName,
	initialCategorySpec,
} from '@kinderlabs-pos/shared-data-type';
import { StoreInfoState } from '@kinderlabs-pos/state';
import { CardStack } from '@kinderlabs-pos/ui-atoms';
import { FullSizeCircularProgress } from '@kinderlabs-pos/ui-components';
import { Stack, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';

export const ProductStatisticsInPos = ({
	selectedDeviceInfoList,
	option,
}: {
	selectedDeviceInfoList?: SalesDeviceInfoType[];
	option: DayCalendarFilterOptionType;
}) => {
	const { storeId } = useAtomValue(StoreInfoState.curStoreAndDevice);

	return (
		<CardStack
			spacing={1}
			height={'100%'}
			overflow={'auto'}>
			<Stack alignItems={'center'}>
				<Typography variant='h3'>{`${
					selectedDeviceInfoList
						? selectedDeviceInfoList.map((d) => getSalesDeviceInfoName(d)).join(', ')
						: ''
				} 품목별 매출`}</Typography>
			</Stack>
			<Suspense fallback={<FullSizeCircularProgress />}>
				<Stack
					flex={1}
					overflow='auto'>
					<상품별매출통계테이블
						storeId={storeId}
						selectedPosIdList={selectedDeviceInfoList?.map((p) => p.id)}
						calendarOption={option}
					/>
				</Stack>
			</Suspense>
		</CardStack>
	);
};

// 이렇게 안하면 무한렌더링 발생
const statisticsType: 상품매출커스터마이즈종류Type = {
	pageType: '매출',
	상세정보보기: true,
	옵션합쳐보기: true,
};

const 상품별매출통계테이블 = ({
	storeId,
	selectedPosIdList,
	calendarOption,
}: {
	storeId: number;
	selectedPosIdList?: number[];
	calendarOption: DayCalendarFilterOptionType;
}) => {
	const { data: dataRows } = NewProductStatisticsData.useData({
		filter: {
			dateType: 'DAY',
			storeIdList: [storeId],
			posIdList: selectedPosIdList,
			calendarOption,
			categorySpec: initialCategorySpec,
		},
		statisticsType,
	});

	const columns = NewProductStatisticsData.usePosTableColumnInfo();

	const { table, TableComponent } = useSimpleReactTable({
		reactTableOptions: {
			columns,
			data: dataRows,
			initialState: {
				columnPinning: { left: ['name'] },
			},
		},
	});

	return <TableComponent />;
};
